/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1EmailTemplateConfig } from '../models/V1EmailTemplateConfig';
import { V1SlackTemplateConfig } from '../models/V1SlackTemplateConfig';
import { HttpFile } from '../http/http';

export class V1Route {
    'id'?: string;
    'routeIdentifier'?: string;
    'templateConfigs'?: Array<V1EmailTemplateConfig>;
    'slackTemplateConfigs'?: Array<V1SlackTemplateConfig>;
    'userCanTrigger'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "routeIdentifier",
            "baseName": "route_identifier",
            "type": "string",
            "format": ""
        },
        {
            "name": "templateConfigs",
            "baseName": "template_configs",
            "type": "Array<V1EmailTemplateConfig>",
            "format": ""
        },
        {
            "name": "slackTemplateConfigs",
            "baseName": "slack_template_configs",
            "type": "Array<V1SlackTemplateConfig>",
            "format": ""
        },
        {
            "name": "userCanTrigger",
            "baseName": "user_can_trigger",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1Route.attributeTypeMap;
    }

    public constructor() {
    }
}

